import { TreeMap } from "..";
import { Container } from "./style";

export const StockExchange = ({ panel, value }) => {
  const getNegative = (value) => {
    if (value.indexOf("-") > -1) {
      return (
        <span className="variation-negative">{value.replace("%", "")}</span>
      );
    }
    {
      return (
        <span className="variation-positive">+{value.replace("%", "")}</span>
      );
    }
  };
  return (
    <Container>
      <div className="title-stock">
        <p>Bolsas</p>
      </div>

      <div className="merval-container">
        {/* <div className="merval-screener">
          <h2>Stock screener Merval</h2>
          <TreeMap dataMap={panel} />
          <ul>
            <li style={{ backgroundColor: "#ff0000" }}>-3%</li>
            <li style={{ backgroundColor: "#be3e4c" }}>-2%</li>
            <li style={{ backgroundColor: "#864652" }}>-1%</li>
            <li style={{ backgroundColor: "#574952" }}>-0,2%</li>
            <li style={{ backgroundColor: "#444557" }}>0</li>
            <li style={{ backgroundColor: "#495753" }}>+0,2%</li>
            <li style={{ backgroundColor: "#377751" }}>+1%</li>
            <li style={{ backgroundColor: "#3c9a5b" }}>+2%</li>
            <li style={{ backgroundColor: "#38cb61" }}>+3%</li>
          </ul>
          <p className="scale-description">
            Los tamaños representan el volumen negociado
          </p>
        </div> */}
        <div className="merval-panel">
          <h2>Panel Merval</h2>
          <table>
            <thead>
              <tr>
                <th>Especie</th>
                <th>Último Valor</th>
                <th>Var. Diaria</th>
              </tr>
            </thead>
            <tbody>
              {panel.map((item, index) => (
                <tr className="tr-body" key={`tr${index}`}>
                  <td>{item.papel}</td>
                  <td>{item.ultimo}</td>
                  <td>{getNegative(item.variacao)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="last-value">{`Último valor obtenido al ${panel?.[0]?.data?.replaceAll(
            "/",
            "."
          )} - ${panel?.[0]?.hora}`}</p>
        </div>
      </div>
      <div className="other-currency-grid">
        {value.map((bond, index) => (
          <div className="card" key={`bond${index}`}>
            <div className="card-content">
              <h2>{bond.descricao}</h2>
              <p className="dotted-border value">{bond.ultimo}</p>
              <div className="currency-info">
                <p className="dotted-border variation">
                  Variable
                  {getNegative(bond.variacao)}
                </p>

                <p className="dotted-border">
                  Anterior <span>{bond.fechant}</span>
                </p>
              </div>
              <p className="last-value">{`Último valor obtenido al ${bond.data} - ${bond.hora}`}</p>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
};
